var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0676 15.5V11.2672H18.9332V15.5H23.0676ZM23.0676 32.3328V19.7328H18.9332V32.3328H23.0676ZM6.13633 7.03438C10.2707 2.9 15.2254 0.832815 21.0004 0.832815C26.7754 0.832815 31.6973 2.9 35.766 7.03438C39.9004 11.1031 41.9676 16.025 41.9676 21.8C41.9676 27.575 39.9004 32.5297 35.766 36.6641C31.6973 40.7328 26.7754 42.7672 21.0004 42.7672C15.2254 42.7672 10.2707 40.7328 6.13633 36.6641C2.06758 32.5297 0.0332045 27.575 0.0332045 21.8C0.0332045 16.025 2.06758 11.1031 6.13633 7.03438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0fb575b716ae841c075103c25864b984.svg";
export { ForwardRef as ReactComponent };